export default __webpack_public_path__ + "static/media/featured4.png";